var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.593,
    height: 11.852,
    viewBox: "0 0 16.593 11.852",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2",
    transform: "translate(-2 -6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_37400",
    "data-name": "Tracciato 37400",
    d: "M2.866,6.26A1.754,1.754,0,0,1,3.778,6H16.815a1.754,1.754,0,0,1,.912.26L10.625,11a.593.593,0,0,1-.658,0Zm8.415,5.721a1.774,1.774,0,0,1-1.972,0l-7.2-4.8a1.751,1.751,0,0,0-.111.6v8.3a1.778,1.778,0,0,0,1.778,1.778H16.815a1.778,1.778,0,0,0,1.778-1.778v-8.3a1.765,1.765,0,0,0-.11-.6Z",
    transform: "translate(0)",
    fill: "#979797"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.15955ea5b53d2559c999c6ab2226d12f.svg";
export { ForwardRef as ReactComponent };